import { Routes, Route } from "react-router-dom";
import Start from "./pages/start";
import Rules from "./pages/rules";
import Ranking from "./pages/ranking";
import "./App.css";
import { PointsProvider } from "./providers/PointsContext";
import Quiz from "./pages/quiz";
import Thanks from "./pages/thanks";
import Conditions from "./pages/conditions";
import Gdpr from "./pages/gdpr";
import { CurrentPageProvider } from "./providers/CurrentPageContext";
import { ModalProvider, useModal } from './providers/ModalContext';
import Modal from './components/Modal';

function App() {
  return (
    <CurrentPageProvider>
      <PointsProvider>
        <div className="App">
          <ModalProvider>
            <Modal/>
          <Routes>
            <Route path="/" index element={<Start />} />
            <Route path="/tävlingsregler" element={<Rules />} />
            <Route path="/villkor" element={<Conditions />} />
            <Route path="/topplistan" element={<Ranking />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/tack" element={<Thanks />} />
            <Route path="/gdpr" element={<Gdpr />} />
          </Routes>
          </ModalProvider>
        </div>
      </PointsProvider>
    </CurrentPageProvider>
  );
}

export default App;
